import _ from "lodash";
import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";

import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { PencilOutlined, MinusCircleOutlined } from "@toddle-edu/ds-icons";
import UIBaseComponent from "UIComponents/UIBaseComponent";

import { getLearningGoalsDataMemoize } from "Assessments/modules/Utils";
import { getCurrentCurriculumProgramType } from "modules/CommonSelectors";
import { htmlToText } from "Utils/HTMLHelpers";

import LearningGoalsModal from "../AddLearningGoals/components/LearningGoalsModal";
import DiscardLearningGoalsModal from "../AddLearningGoals/components/DiscardLearningGoalsModal";
import classes from "./LearningGoalsListView.scss";
import { getStyleStrippedText } from "Utils";
import { getIsLearningGoalsRevampEnabled } from "Worksheet/modules/WorksheetFeatureFlags";
import AssessmentLearningGoals from "AppComponents/AssessmentLearningGoals";
import { ASSESSMENT } from "Constants/stringConstants";

class LearningGoalsListView extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      isEditModalVisible: false,
      isRemoveModalVisible: false,
    };
  }

  isValidValue = value => {
    return !!value && !_.isEmpty(value);
  };

  onEditIconClick = e => {
    e?.stopPropagation();
    this.setState({
      isEditModalVisible: true,
    });
  };

  onRemoveIconClick = e => {
    e?.stopPropagation();
    this.setState({
      isRemoveModalVisible: true,
    });
  };

  onCloseLearningGoalsModal = () => {
    this.setState({ isEditModalVisible: false });
  };

  onCloseDiscardModal = () => {
    this.setState({ isRemoveModalVisible: false });
  };

  onRemoveLearningGoals = () => {
    const { updateInputField, fieldKey } = this.props;
    updateInputField({ [fieldKey]: [] }, { nodes: [] });
  };

  getLearningGoalsDataParams = () => {
    const {
      unitPlanFields,
      assessmentFields,
      curriculumType,
      fieldKey,
      plannerElementConfig: { type } = {},
      courseId,
      field_list,
      learningCourseId,
    } = this.props;

    const fieldObj = _.get(field_list, fieldKey, {});
    const config = _.get(fieldObj, "config", {});

    const { type: fieldType, options: fieldObjConfigOptions = [] } =
      config || {};

    const isPlannerElement = _.includes(
      ["PLANNER_ELEMENT", "PYP_PLANNER_ELEMENT"],
      fieldType
    );

    return {
      fieldKey,
      plannerElementType: type,
      unitPlanFields,
      assessmentFields,
      curriculumType,
      mode: "view",
      courseId,
      fieldObjConfigOptions,
      isPlannerElement,
      learningCourseId,
    };
  };

  renderEditIcon = () => {
    const { t, testId } = this.props;

    return (
      <Tooltip tooltip={t("common:edit")} showArrow={true}>
        <div className={classes.editIcon}>
          <IconButton
            dsVersion="2.0"
            icon={<PencilOutlined variant="subtle" />}
            variant="neutral"
            type="plain"
            size="small"
            onClick={this.onEditIconClick}
            testId={`${testId}-edit`}
          />
        </div>
      </Tooltip>
    );
  };

  renderRemoveIcon = () => {
    const { t, testId, isFromQuestion } = this.props;

    const removeIconClasses = classNames(classes.removeIcon, {
      [classes.questionView]: isFromQuestion,
    });
    return (
      <Tooltip tooltip={t("common:remove")} showArrow={true}>
        <div className={removeIconClasses}>
          <IconButton
            dsVersion="2.0"
            icon={<MinusCircleOutlined variant="subtle" />}
            variant="neutral"
            type="plain"
            size="small"
            onClick={this.onRemoveIconClick}
            testId={`${testId}-remove`}
          />
        </div>
      </Tooltip>
    );
  };

  renderLearningGoalsModal = () => {
    const {
      unitPlanFields,
      assessmentFields,
      updateInputField,
      fieldKey,
      field_list,
      plannerElementConfig: { type: plannerElementType } = {},
      selectedCourseId,
      assessmentType,
      viewLabel,
      viewLabelLocale,
      templateId,
      assessmentTools,
      testId,
      label,
      getLearningGoalsTagCountTooltip,
      curriculumProgram,
      learningCourseId,
    } = this.props;

    const fieldObj = _.get(field_list, fieldKey, {});

    const { config = {}, type } = fieldObj;

    const { type: fieldType, options: fieldObjConfigOptions = [] } =
      config || {};

    const isPlannerElement = _.includes(
      ["PLANNER_ELEMENT", "PYP_PLANNER_ELEMENT"],
      fieldType
    );

    return (
      <LearningGoalsModal
        type={type}
        fieldKey={fieldKey}
        fieldLabel={label}
        unitPlanFields={unitPlanFields}
        assessmentFields={assessmentFields}
        plannerElementType={plannerElementType}
        updateInputField={updateInputField}
        onCloseLearningGoalsModal={this.onCloseLearningGoalsModal}
        isPlannerElement={isPlannerElement}
        selectedCourseId={selectedCourseId}
        assessmentType={assessmentType}
        viewLabel={viewLabel}
        viewLabelLocale={viewLabelLocale}
        templateId={templateId}
        assessmentTools={assessmentTools}
        testId={testId}
        fieldObjConfigOptions={fieldObjConfigOptions}
        shouldUpdateActiveQuestionOnClick={false}
        getLearningGoalsTagCountTooltip={getLearningGoalsTagCountTooltip}
        curriculumProgram={curriculumProgram}
        learningCourseId={learningCourseId}
      />
    );
  };

  renderAssessmentLearningGoals = () => {
    const {
      fieldKey,
      field_list,
      unitPlanFields,
      courseSubjects,
      updateInputField,
      assessmentFields,
      hasAddRemoveValues,
      assignmentSubjects,
      selectedLearningGoal,
      defaultOptions,
      unitPlanTemplate,
      getLearningGoalsTagCountTooltip,
      subFields,
      parentId,
      parentType,
    } = this.props;

    return (
      <AssessmentLearningGoals
        field_list={field_list}
        unitPlanFields={unitPlanFields}
        courseSubjects={courseSubjects}
        updateInputField={updateInputField}
        assessmentFields={assessmentFields}
        hasAddRemoveValues={hasAddRemoveValues}
        assignmentSubjects={assignmentSubjects}
        selectedLearningGoal={selectedLearningGoal}
        defaultOptions={defaultOptions}
        unitPlanTemplate={unitPlanTemplate}
        getLearningGoalsTagCountTooltip={getLearningGoalsTagCountTooltip}
        subFields={subFields}
        onClose={this.onCloseLearningGoalsModal}
        selectedLearningGoalKey={fieldKey}
        assessmentId={parentType === ASSESSMENT ? parentId : null}
      />
    );
  };

  renderLearningGoalsRemoveModal = () => {
    const { t, assessmentType, label } = this.props;

    const { value } = getLearningGoalsDataMemoize(
      this.getLearningGoalsDataParams()
    );
    const totalSelectedNodes = _.size(value);

    const assessmentTypeTitle =
      assessmentType == "le"
        ? t("common:learning_experience")
        : t("common:assessment");

    const message = t("classRoom:remove_selected_learning_goals_message", {
      count: totalSelectedNodes,
      label,
      type: assessmentTypeTitle,
    });

    return (
      <DiscardLearningGoalsModal
        headerTitle={t("classRoom:remove_selected_learning_goals")}
        message={message}
        buttonLabel1={t("common:keep")}
        buttonLabel2={t("common:remove")}
        onClickButton1={this.onCloseDiscardModal}
        onClickButton2={this.onRemoveLearningGoals}
        onCloseDiscardModal={this.onCloseDiscardModal}
      />
    );
  };

  renderFlatList = () => {
    const { getLearningGoalsTagCountTooltip } = this.props;
    const params = this.getLearningGoalsDataParams();
    const { nodes, value } = getLearningGoalsDataMemoize(params);
    const options = _.get(params, "isPlannerElement", false) ? nodes : value;

    const codeClasses = classNames("text-textSubtle", classes.codeLabel);
    const labelClasses = classNames("text-body-2", classes.label, {
      [classes.rightEndLabelContainerClass]: !_.isNil(
        getLearningGoalsTagCountTooltip?.(value, true)
      ),
    });

    return _.map(options, node => {
      const { id, value, label, code } = node || {};
      const key = id || value;

      return (
        <div key={key} className={labelClasses}>
          <span>
            {htmlToText(label)}
            {code ? (
              <span
                className={codeClasses}
                dangerouslySetInnerHTML={{
                  __html: ` (${getStyleStrippedText({
                    text: code,
                    type: "SNS_EDITOR",
                  })})`,
                }}
              />
            ) : null}
          </span>
          {getLearningGoalsTagCountTooltip?.(key, true)}
        </div>
      );
    });
  };

  renderView = () => {
    return (
      <div className={classes.container}>
        <div className={classes.innerContainer}>{this.renderFlatList()}</div>
      </div>
    );
  };

  renderEdit = () => {
    const { isEditModalVisible, isRemoveModalVisible } = this.state;
    const isLearningGoalsRevampEnabled = getIsLearningGoalsRevampEnabled();

    const renderEditModal = () => {
      if (!isEditModalVisible) {
        return null;
      }
      return isLearningGoalsRevampEnabled
        ? this.renderAssessmentLearningGoals()
        : this.renderLearningGoalsModal();
    };

    return (
      <div className={classes.container}>
        <div className={classes.innerContainer}>{this.renderFlatList()}</div>
        {renderEditModal()}
        {isRemoveModalVisible ? this.renderLearningGoalsRemoveModal() : null}
        {this.renderEditIcon()}
        {this.renderRemoveIcon()}
      </div>
    );
  };
}

const mapStatetoProps = (state, ownProps) => {
  const selectedCourseId = _.get(
    state,
    "teacher.selected_class.selected_course"
  );
  const courseId = ownProps?.selectedCourseId || selectedCourseId;

  return {
    courseId,
    curriculumType:
      getCurrentCurriculumProgramType(state) ||
      _.get(ownProps, "curriculumType"),
  };
};

export default connect(mapStatetoProps, null)(LearningGoalsListView);
